// assets/header-predictive-search.js
// HeaderBig 用：入力すると候補が出る Ajax 検索

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var input = document.querySelector("[data-header-search-input]");
    var results = document.querySelector("[data-header-search-results]");
    if (!input || !results) return;

    var wrapper = results.closest("[data-header-search-wrapper]");
    var currentRequest = null;
    var debounceTimer = null;

    function hideResults() {
      results.innerHTML = "";
      results.hidden = true;
      input.setAttribute("aria-expanded", "false");
    }

    function showResults() {
      if (!results.innerHTML.trim()) {
        hideResults();
        return;
      }
      results.hidden = false;
      input.setAttribute("aria-expanded", "true");
    }

    function buildResultsHTML(data, query) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (!products.length) {
        return "";
      }

      var html = "";
      html += '<div class="HeaderBig__SearchResultsTitle">SUGGESTED PRODUCTS</div>';
      html += '<ul class="HeaderBig__SearchResultList">';

      products.forEach(function (p) {
        var firstImage = (p.image && p.image) || null;
        var price = (p.price && p.price) || null;

        html += '<li class="HeaderBig__SearchResultItem">';
        html += '<a class="HeaderBig__SearchResultLink" href="' + p.url + '">';

        if (firstImage && firstImage != null) {
          html +=
            '<img class="HeaderBig__SearchResultThumb" src="' +
            firstImage +
            '" alt="' +
            (p.title || "") +
            '">';
        }

        html += '<div class="HeaderBig__SearchResultText">';
        html += '<div class="HeaderBig__SearchResultTitle">' + (p.title || "") + "</div>";

        if (price) {
          html += '<div class="HeaderBig__SearchResultPrice">' + price + "</div>";
        }

        html += "</div>"; // text
        html += "</a>";
        html += "</li>";
      });

      html += "</ul>";

      html +=
        '<div class="HeaderBig__SearchResultsFooter">' +
        '<a href="/search?q=' +
        encodeURIComponent(query) +
        '">VIEW ALL RESULTS</a>' +
        "</div>";

      return html;
    }

    function fetchSuggestions(query) {
      if (currentRequest && typeof currentRequest.abort === "function") {
        currentRequest.abort();
      }

      var controller = new AbortController();
      currentRequest = controller;

      var params = new URLSearchParams();
      params.set("q", query);
      params.set("resources[type]", "product");
      params.set("resources[limit]", "4");
      params.set("section_id", "predictive-search"); // セクションを使っているテーマでもOKなように

      fetch("/search/suggest.json?" + params.toString(), {
        signal: controller.signal,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      })
        .then(function (res) {
          if (!res.ok) throw new Error("Network error");
          return res.json();
        })
        .then(function (data) {
          var html = buildResultsHTML(data, query);
          if (!html) {
            hideResults();
            return;
          }
          results.innerHTML = html;
          showResults();
        })
        .catch(function (err) {
          if (err.name === "AbortError") return;
          hideResults();
        });
    }

    input.addEventListener("input", function () {
      var value = this.value.trim();

      if (!value || value.length < 2) {
        hideResults();
        return;
      }

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        fetchSuggestions(value);
      }, 250);
    });

    // フォーカス時に、既に結果があれば表示
    input.addEventListener("focus", function () {
      if (results.innerHTML.trim()) {
        showResults();
      }
    });

    // ESCキーで閉じる
    input.addEventListener("keydown", function (evt) {
      if (evt.key === "Escape") {
        hideResults();
        input.blur();
      }
    });

    // フォーカスが外れたとき（少し遅らせてリンククリックを許可）
    document.addEventListener("click", function (event) {
      if (!wrapper.contains(event.target)) {
        hideResults();
      }
    });
  });
})();